export default __webpack_public_path__ + "static/media/zendesk-icon.cd93ac00.svg";